<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__group">
        <div class="weui-cells__title">基础信息</div>
        <custom-layout class="weui-cells" :view-config="customViewConfig">
          <date-field
            slot="as_date"
            :label="customLabel.as_date || '投诉日期'"
            v-model="form.main.as_date"
          />
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="as_urgency"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_urgency || "紧急程度"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.as_urgency"
                placeholder="请选择"
              >
                <option>非常紧急</option>
                <option>一般紧急</option>
                <option>不紧急</option>
              </select>
            </div>
          </div>
          <customer-field
            slot="as_custname"
            :label="customLabel.as_custname || '客户名称'"
            v-model="form.main.as_custname"
            @select="onSelectCustomer"
          />
          <div class="weui-cell" slot="as_contact">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_contact || "投诉人"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.as_contact"
                placeholder="请输入"
              />
            </div>
          </div>
          <div class="weui-cell" slot="as_tel">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_tel || "联系电话"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.as_tel"
                placeholder="请输入"
              />
            </div>
          </div>
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="as_classify"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_classify || "售后类型"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.as_classify"
                placeholder="请选择"
              >
                <option>客户投诉</option>
                <option>产品维修</option>
                <option>售后退货</option>
                <option>其他</option>
              </select>
            </div>
          </div>
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="as_way"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_way || "售后来源"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.as_way"
                placeholder="请选择"
              >
                <option>电话</option>
                <option>微信</option>
                <option>QQ</option>
                <option>邮箱</option>
                <option>面谈</option>
                <option>其他</option>
              </select>
            </div>
          </div>
          <employee-field
            slot="as_dutyer"
            :label="customLabel.as_dutyer || '责任人'"
            v-model="form.main.as_dutyer"
            @select="onSelectEmployee"
          />
        </custom-layout>
      </div>
      <div class="weui-cells__title">问题详情</div>
      <custom-layout
        class="weui-cells"
        :view-config="customViewConfig"
        v-if="
          form.main.as_classify == '客户投诉' || form.main.as_classify == '其他'
        "
      >
        <div class="weui-cells__group" slot="as_content">
          <div class="weui-cells__title bold">详情内容</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_content"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_content ? form.main.as_content.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_why">
          <div class="weui-cells__title bold">原因分析</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_why"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_why ? form.main.as_why.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_short_policy">
          <div class="weui-cells__title bold">临时对策</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_short_policy"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_short_policy
                      ? form.main.as_short_policy.length
                      : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_improve">
          <div class="weui-cells__title bold">改善对策</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_improve"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_improve ? form.main.as_improve.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_effect">
          <div class="weui-cells__title bold">效果验证</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_effect"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_effect ? form.main.as_effect.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_long_policy">
          <div class="weui-cells__title bold">防止再发生对策</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_long_policy"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_long_policy
                      ? form.main.as_long_policy.length
                      : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cells__group" slot="as_quality">
          <div class="weui-cells__title bold">品质确认</div>
          <div class="weui-cells">
            <div class="weui-cell">
              <div class="weui-cell__bd">
                <textarea
                  class="weui-textarea"
                  placeholder="请输入"
                  rows="3"
                  v-model="form.main.as_quality"
                  maxlength="100"
                ></textarea>
                <div class="weui-textarea-counter">
                  <span>{{
                    form.main.as_quality ? form.main.as_quality.length : 0
                  }}</span
                  >/100
                </div>
              </div>
            </div>
          </div>
        </div>
      </custom-layout>
      <div
        v-if="
          form.main.as_classify == '产品维修' ||
          form.main.as_classify == '售后退货'
        "
      >
        <custom-layout :view-config="customViewConfig" class="weui-cells">
          <product-field
            slot="as_prodcode"
            :label="customLabel.as_prodcode || '产品编号'"
            v-model="form.main.as_prodcode"
            @select="onSelectProduct"
          />
          <div class="weui-cell" slot="pr_detail">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_detail || "产品名称"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <span>{{ form.main.pr_detail }}</span>
            </div>
          </div>
          <div class="weui-cell" slot="pr_orispeccode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <span>{{ form.main.pr_orispeccode }}</span>
            </div>
          </div>
          <div class="weui-cell" slot="pr_spec">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_spec || "产品规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <span>{{ form.main.pr_spec }}</span>
            </div>
          </div>
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="as_shelflife"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_shelflife || "保质期"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.as_shelflife"
                placeholder="请选择"
              >
                <option>是</option>
                <option>否</option>
              </select>
            </div>
          </div>
          <div class="weui-cell" slot="as_qty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_qty || "数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.main.as_qty"
                placeholder="请填写"
              />
            </div>
          </div>
          <order-field  slot="as_salecode"
            v-model="form.main.as_salecode"
            @select="onSelectVendor"
          />
          <div
            class="weui-cell"
            slot="as_sn"
            v-if="form.main.as_classify == '产品维修'"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_sn || "S/N"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.as_sn"
                placeholder="请输入"
              />
            </div>
          </div>
          <div
            class="weui-cell"
            slot="as_batchcode"
            v-if="form.main.as_classify == '售后退货'"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.as_batchcode || "批次号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.as_batchcode"
                placeholder="请输入"
              />
            </div>
          </div>
        </custom-layout>
        <custom-layout :view-config="customViewConfig">
          <div class="weui-cells weui-cells__group" slot="as_describe">
            <div class="weui-cells__title bold">
              {{ customLabel.as_describe || "描述" }}
            </div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__bd">
                  <textarea
                    class="weui-textarea"
                    placeholder="请输入"
                    rows="3"
                    v-model="form.main.as_describe"
                    maxlength="100"
                  ></textarea>
                  <div class="weui-textarea-counter">
                    <span>{{
                      form.main.as_describe ? form.main.as_describe.length : 0
                    }}</span
                    >/100
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="weui-cells weui-cells__group" slot="as_why">
            <div class="weui-cells__title bold">
              {{ customLabel.as_describe || "原因分析" }}
            </div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__bd">
                  <textarea
                    class="weui-textarea"
                    placeholder="请输入"
                    rows="3"
                    v-model="form.main.as_why"
                    maxlength="100"
                  ></textarea>
                  <div class="weui-textarea-counter">
                    <span>{{
                      form.main.as_why ? form.main.as_why.length : 0
                    }}</span
                    >/100
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="weui-cells weui-cells__group" slot="as_measure">
            <div class="weui-cells__title bold">
              {{ customLabel.as_measure || "处理方法" }}
            </div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__bd">
                  <textarea
                    class="weui-textarea"
                    placeholder="请输入"
                    rows="3"
                    v-model="form.main.as_measure"
                    maxlength="100"
                  ></textarea>
                  <div class="weui-textarea-counter">
                    <span>{{
                      form.main.as_measure ? form.main.as_measure.length : 0
                    }}</span
                    >/100
                  </div>
                </div>
              </div>
            </div>
          </div>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import ProductField from "@/components/field/ProductField.vue";
import OrderField from "@/components/field/OrderField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DateField,
    EmployeeField,
    CustomerField,
    ProductField,
    OrderField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/sale/afterSale",
      codeField: "as_code",
      statusField: "as_status_code",
      caller: "AfterSale",
      xtype: "sale-afterSale-formpanel",
      form: {
        main: {
          as_classify: "客户投诉",
          as_shelflife: "是",
        },
      },
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.as_date) {
        me.$weui.topTips("请选择投诉日期", 2000);
      } else if (!main.as_custname) {
        me.$weui.topTips("请选择客户名称", 2000);
      } else if (!main.as_classify) {
        me.$weui.topTips("请选择售后类型", 2000);
      } else {
        me.p_save();
      }
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.as_dutyerid = selection.id;
    },
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var main = this.form.main;
      main.as_custid = selection.id;
      main.as_custcode = selection.cu_code;
    },
    onSelectProduct(selection) {
      var me = this,
        main = me.form.main;
      main.as_prodid = selection.id;
      main.as_prodcode = selection.pr_code;
      main.pr_detail = selection.pr_detail;
      main.pr_spec = selection.pr_spec;
      main.pr_orispeccode = selection.pr_orispeccode;
      main.pr_unit = selection.pr_unit;
    },
    onSelectVendor(selection) {
      var me = this,
        main = me.form.main;
      main.as_salecode = selection.sa_code;
    },
  },
};
</script>

<style scoped>
.bold {
  color: #000;
  font-size: 17px;
}
</style>